import { ComponentRef, ViewContainerRef } from '@angular/core';
import { PopupComponent } from './popup.component';

declare var jQuery: any;

export abstract class DialogCreator {

    private winRefs: Map<PopupComponent, ComponentRef<any>> = new Map<PopupComponent, ComponentRef<any>>();

    //override this method in a descendant
    abstract getViewContainerRef(): ViewContainerRef;

    createDialog(windowClass: any) {

        let ref = this.getViewContainerRef().createComponent(windowClass);

        const popup = <PopupComponent>ref.instance;

        this.winRefs.set(popup, ref);

        popup.setDialogCreator(this);

        return ref.instance;

    }

    destroyDialog(window: PopupComponent) {

        let temp = this.winRefs.get(window);
        if (!temp) return;

        const ind = this.getViewContainerRef().indexOf(temp.hostView);

        if (ind !== -1)
            this.getViewContainerRef().remove(ind);

        this.winRefs.delete(window);

    }

    public getWinByEl(el: HTMLElement): PopupComponent | undefined {

        let win: PopupComponent | undefined;

        this.winRefs.forEach((winref, instance) => {

            let res = jQuery(winref.location.nativeElement).find(el);
            if (res.length) win = instance;

        });

        return win;

    }
    
    public getWinByClass(componentClass: any){
        if (this.winRefs && this.winRefs.size > 0) {
            for (var key of this.winRefs.keys()) {
                if (key instanceof componentClass)
                    return key;
            }
        }
    }

    abstract getElement(): Element;

    public getNoModalMaxZIndex(exeptPopup?: PopupComponent): number {

        let maxZ = 0;

        this.winRefs.forEach((winref, instance) => {

            if (instance != exeptPopup &&
                !instance.isModal &&
                !instance.isTopest() &&
                !instance.isHidden() &&
                !instance.wasClosed &&
                instance.getZIndex() !== undefined &&
                maxZ < instance.getZIndex()!)
            maxZ = instance.getZIndex()!;
        });

        return maxZ;

    }

    public getWinRefs(): Map<PopupComponent, ComponentRef<any>> {
        return this.winRefs ?? new Map<PopupComponent, ComponentRef<any>>();
    }
}
